import React, {useState, useEffect, useRef} from "react";
import * as palette from "../Variables";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Placeholder from "../img/placeholder.jpg";
import styled from "styled-components";
import WorkHero from "../components/WorkHero";
import Insight from "../components/Insight";
import Competitor from "../components/Competitor";
import PainPoint from "../components/PainPoint";
import StickyNav from "../components/StickyNav";
import Persona from "../components/Persona";
import WorkRecommendation from "../components/WorkRecommendation";
import HeroImgDesktop from "../img/insight/insight-hero-desktop.jpg";
import HeroImgMobile from "../img/insight/insight-hero-mobile.jpg";
import DesignProcess from "../img/design-process.png";
import Competitor1 from "../img/insight/insight-competitor-1.jpg";
import Competitor2 from "../img/insight/insight-competitor-2.jpg";
import TargetAudiencePink from "../img/target-audience-pink.png";
import TargetAudienceOrange from "../img/target-audience-orange.png";
import TargetAudienceBlue from "../img/target-audience-blue.png";
import UserJourneyAppDesktop from "../img/insight/insight-app-userjourney-desktop.png";
import UserJourneyAppMobile from "../img/insight/insight-app-userjourney-mobile.png";
import UserJourneyARDesktop from "../img/insight/insight-ar-userjourney-desktop.png";
import UserJourneyARMobile from "../img/insight/insight-ar-userjourney-mobile.png";
import ARSketches from "../img/insight/insight-ar-sketches.jpg";
import AppSketches from "../img/insight/insight-app-sketches.jpg";
import GlassesSketches from "../img/insight/insight-glasses-sketches.jpg";
import FinalApp from "../img/insight/insight-final.jpg";
import FinalGlasses from "../img/insight/insight-final-glasses.jpg";
import Persona1 from "../img/insight/insight-persona-1.jpg";
import Persona2 from "../img/insight/insight-persona-2.jpg";
import DignifiThumbnail from "../img/dignifi/dignifi-thumbnail.png";
import SmartHomeThumbnail from "../img/smart-home/smart-home-thumbnail.png";
import SouthwestThumbnail from "../img/southwest/southwest-thumbnail.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';


const WorkSection = styled.section`
    padding-top: 44px;
    padding-bottom: 44px;
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    flex-flow: column nowrap;
    row-gap: 44px;

    &.grey {
        background-color: ${palette.neutral2};
    }

    &.challenge {
        background: ${palette.gradientMain};

        p, h2 {
            color: ${palette.neutral1};
        }

        p.description {
            font-size: 22px;
        }
    }

    .work-recommendation-container {
        width: 100%;

        @media (min-width: 400px) {
            width: 48%;
        }

        @media (min-width: 650px) {
            width: 32%;
        }
    }

    a:focus-visible {
        outline: 3px solid ${palette.blueMain};
        outline-offset: 8px;
        border-radius: 4px;
    }

    .container.main-container {
        @media (min-width: 1200px) {
            margin-left: 250px;
        }

        @media (min-width: 1600px) {
            margin-left: auto;
        }
    }

    &.reflections {
        background: ${palette.blueMain};

        .label, .h3, p.h4, p {
            color: ${palette.neutral1};
        }

        .summary {
            margin-bottom: 40px;
        }
    }

    .no-left-padding, .no-right-padding {
        padding-left: 0;
        padding-right: 0;
    }

    .h3, .section-title {
        margin-bottom: 16px;
    }

    .img-caption {
        color: ${palette.neutral9};
        margin-bottom: 0 !important;
        margin-top: 16px;

        &.margin-bottom-16 {
            margin-bottom: 16px !important;
        }
    }

    img {
        border-radius: 8px;
    }

    img.placeholder {
        aspect-ratio: 2/1;
    }

    .work-recommendation-container.left {

        @media (min-width: 576px) {
            padding-right: 24px;
        }
    }

    .work-recommendation-container.middle {

        @media (min-width: 576px) {
            padding-left: 24px;
        }

        @media (min-width: 992px) {
            padding-left: 12px;
            padding-right: 12px;
        }
    }

    .work-recommendation-container.right {

        display: none;

        @media (min-width: 992px) {
            display: block;
            padding-left: 24px;
        }
    }

    @media (min-width: 768px) {
        padding-top: 72px;
        padding-bottom: 72px;
        padding-left: 24px;
        padding-right: 24px;
        row-gap: 72px;

        .no-left-padding {
            padding-left: 0;
        }

        .no-right-padding {
            padding-right: 0;
        }

        .h3, .section-title {
            margin-bottom: 24px;
        }
    }

    @media (min-width: 1200px) {
        &.first {
            margin-top: -456px;
        }
    }

    @media (min-width: 1300px) {
        &.first {
            margin-top: -456px;
        }
    }

    @media (min-width: 1400px) {
        &.first {
            margin-top: -456px;
        }
    }

    .work-elements {
        row-gap: 24px;
        display: flex;
        flex-flow: column nowrap;

        &.overview {
            h1 {
                margin-bottom: 12px;
            }
        }

        @media (min-width: 768px) {
            row-gap: 52px;

            &.overview {
                h1 {
                    margin-bottom: 24px;
                }
            }
        }

        @media (min-width: 1200px) {
            max-width: 850px;
        }

        @media (min-width: 1250px) {
            max-width: 900px;
        }

        @media (min-width: 1300px) {
            max-width: 940px;
        }

        @media (min-width: 1400px) {
            max-width: 1040px;
        }

        @media (min-width: 1500px) {
            max-width: 1096;
        }


        .neutral-9 {
            color: ${palette.neutral9};
        }

        .competitors-container {
            display: flex;
            flex-flow: row wrap;
            column-gap: 20px;
            row-gap: 16px;

            @media (min-width: 768px) {
                column-gap: 60px;
                row-gap: 24px;
            }
        }

        .insights-container {
            display: flex;
            flex-flow: column nowrap;
            row-gap: 28px;
        }

        .pain-points-container {
            row-gap: 20px;
            display: flex;
            flex-flow: column nowrap;

            @media (min-width: 768px) {
                row-gap: 32px;
            }
        }

        .left {
            @media (min-width: 768px) {
                padding-right: 24px;
            }
        }

        .right {
            @media (min-width: 768px) {
                padding-left: 24px;
            }
        }

        h3.audience1 {
            margin-bottom: 12px;

            @media (min-width: 768px) {
                margin-top: 0;
                margin-bottom: 16px;
            }
        }

        h3.audience2 {
            margin-top: 40px;
            margin-bottom: 12px;
            
            @media (min-width: 768px) {
                margin-top: 0;
                margin-bottom: 16px;
            }
        }
    }

    .personas-container {
        display: flex;
        flex-flow: column nowrap;
        row-gap: 40px;

        @media (min-width: 768px) {
            row-gap: 64px;
        }
    }
`;

const persona1Demographics = (
    <div>
        <p style={{marginBottom: 4}}><span>Age: </span>17 years old<br/></p>
        <p style={{marginBottom: 4}}><span>Occupation: </span>Student<br/></p>
        <p style={{marginBottom: 4}}><span>Location: </span>Portland, Oregon<br/></p>
        <p style={{marginBottom: 4}}><span style={{lineHeight: 1.5}}>Neurodivergent conditions: </span>Autism Spectrum Disorder, sensory processing sensitivity</p>
    </div>
);

const persona1Interests = (
    <ul>
        <li>Drawing anime characters</li>
        <li>Playing cozy video games like Animal Crossing</li>
        <li>Watching YouTube tutorials for art</li>
    </ul>
);

const persona1Aspirations = (
    <ul>
        <li>"I want to make a few close friends I can trust."</li>
        <li>"I'd like to join some clubs at my school for things I'm interested in."</li>
    </ul>
);

const persona1Behaviors = (
    <ul>
        <li>Avoids eye contact in conversation to focus on what's being said</li>
        <li>Communicates better through text or drawing</li>
        <li>Often rehearses what she wants to say in her head before speaking</li>
    </ul>
);

const persona1Frustrations = (
    <ul>
        <li>Struggles to tell when others are joking or being sarcastic</li>
        <li>Doesn’t always know how to enter or exit a conversation</li>
        <li>Finds loud or crowded environments overwhelming</li>
    </ul>
);

const persona2Demographics = (
    <div>
        <p style={{marginBottom: 4}}><span>Age: </span>35 years old<br/></p>
        <p style={{marginBottom: 4}}><span>Occupation: </span>Senior IT Support Analyst<br/></p>
        <p style={{marginBottom: 4}}><span>Location: </span>Chicago, Illinois<br/></p>
        <p style={{marginBottom: 4}}><span style={{lineHeight: 1.5}}>Neurodivergent conditions: </span>ADHD, Autism Spectrum Disorder</p>
    </div>
);

const persona2Interests = (
    <ul>
        <li>Listening to longform podcasts on design, tech, and neurodivergence</li>
        <li>Building mechanical keyboards and modding retro tech</li>
    </ul>
);

const persona2Aspirations = (
    <ul>
        <li>"I want to improve my communication skills to feel more confident in meetings and presentations."</li>
        <li>"I need support that is predictable and low-stress."</li>
    </ul>
);

const persona2Behaviors = (
    <ul>
        <li>Uses visual timers and task chunking to stay on track</li>
        <li>Relies on routines and quiet spaces to recharge socially and cognitively</li>
    </ul>
);

const persona2Frustrations = (
    <ul>
        <li>Still struggles to read subtle facial expressions or tone shifts in meetings</li>
        <li>Can feel isolated when masking becomes exhausting</li>
        <li>Experiences decision fatigue and frustration when digital tools aren't intuitive</li>
    </ul>
);

const UserTesting1 = (
    <ul>
        <li>Add a guided tutorial or tooltips for ambient noise settings</li>
        <li>Clarify labels and improve organization in privacy settings</li>
        <li>Enhance instruction clarity in the microphone permissions menu</li>
        <li>Introduce a physical tap feature to control noise-canceling</li>
        <li>Simplify navigation for font size settings</li>
        <li>Enable easy switching between individual and group emotion analysis modes</li>
        <li>Improve daily goal adjustment interfaces for a smoother experience</li>
    </ul>
);

const UserTesting2 = (
    <ul>
        <li>Clearly indicate numeric goal values and add distinct labeling for goal editing</li>
        <li>Introduce statistics for time spent with favorite individuals</li>
        <li>Allow temporary or permanent goal changes</li>
        <li>Consider adding the functionality to log emotions through the glasses</li>
    </ul>
);

const InSightAppDesign = () => {
    const [scrollY, setScrollY] = useState(window.scrollY);
    
    useEffect(() => {
        const handleScroll = () => setScrollY(window.scrollY);
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const getScrollMarginTop = (ref) => {
        if (!ref.current) return 0;
        const sectionTop = ref.current.getBoundingClientRect().top + window.scrollY;
        return sectionTop > scrollY ? 0 : 135;
    };

    const overviewRef = useRef(null);
    const generalResearchRef = useRef(null);
    const userResearchRef = useRef(null);
    const challengeRef = useRef(null);
    const analysisRef = useRef(null);
    const iterationsRef = useRef(null);
    const finalDesignRef = useRef(null);
    const reflectionsRef = useRef(null);

    const [showHeader, setShowHeader] = useState(true);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1200);
    const lastScrollY = useRef(window.scrollY);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            const isScrollingUp = currentScrollY < lastScrollY.current;
            const isAtTop = currentScrollY < 10;
            const threshold = isDesktop ? 135 : 66;

            if (isScrollingUp || isAtTop) {
                setShowHeader(true);
            } else if (currentScrollY > threshold) {
                setShowHeader(false);
            }
            lastScrollY.current = currentScrollY;
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [isDesktop]);

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth >= 1200);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const stickyBase = 72;
    const headerHeight = isDesktop ? 135 : 66;
    const stickyOffset = showHeader ? stickyBase + headerHeight : stickyBase;

    const [matches, setMatches] = useState(
        window.matchMedia("(min-width: 768px)").matches
    )

    useEffect(() => {
        window
        .matchMedia("(min-width: 768px)")
        .addEventListener('change', e => setMatches( e.matches ));
    }, []);


        <div >
        {matches && (<h1>Big Screen</h1>)}
        {!matches && (<h3>Small Screen</h3>)}
        </div>

    return (
        <main>

            <WorkHero src={HeroImgDesktop} alt={"Prototype of the InSight AR device and three screens from the InSight app"} className={"d-none d-lg-block"}></WorkHero>
            <WorkHero src={HeroImgMobile} alt={"Prototype of the InSight AR device and one screen from the InSight app"} className={"d-lg-none"}></WorkHero>
            <div className={"page-container"}>
                <StickyNav headerOffset={stickyOffset} />
                <WorkSection className={"first"} id="overview" ref={overviewRef} style={{scrollMarginTop: getScrollMarginTop(overviewRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements overview"}>
                                    <div>
                                        <h1 className={"h2"}>InSight AR experience and app&nbsp;design</h1>
                                        <p><span className={"semibold"}>Timeline / </span>Fall 2023</p>
                                        <p><span  className={"semibold"}>Involvement / </span>UX designer on a 5-person team</p>
                                        <p><span  className={"semibold"}>Deliverables / </span>Interactive prototypes for an AR device and connected app</p>
                                        <p><span  className={"semibold"}>UX activities / </span>Paper prototype, usability testing, user flow, branding, UI design</p>
                                        <p><span  className={"semibold"}>Tools used / </span>Figma, Procreate, pen and paper, Adobe Illustrator</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12} lg={9}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"} style={{scrollMarginTop:72}}>Overview</p>
                                        <h2 className={"h3"}>Background</h2>
                                        <p>Many autistic individuals experience difficulty recognizing emotions and nonverbal social cues during conversations, which can lead to stress, confusion, or social withdrawal. To address this, my team created a wearable augmented reality device paired with a connected app to help users better understand emotional context in real time.</p>
                                        <p style={{margin:0}}>The AR interface subtly displays cues to support emotion recognition, while the app offers a gamified approach to tracking progress, planning ahead for social events, and celebrating small wins.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container d-none d-md-block"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>Design process</h2>
                                        <img src={DesignProcess} alt={"Design process: brainstorm, research, analysis, design, user testing, delivery; contains multiple iterations of analysis, design, and user testing."} style={{maxWidth: 900, borderRadius: 0}}></img>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>

                <WorkSection className={"grey"} id={"general-research"} ref={generalResearchRef} style={{scrollMarginTop: getScrollMarginTop(generalResearchRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>General research</p>
                                        <h2 className={"h3"}>Target audience</h2>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                <div className={"insights-container"}>
                                                    <Insight
                                                        number={"01"}
                                                        title={"Neurodivergent people"}
                                                        description={"Autistic people or people with other neurodivergent conditions who struggle with social cues"}>
                                                    </Insight>
                                                </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <h2 className={"h3"}>Competitors</h2>
                                <div className={"work-elements"}>
                                    <p style={{margin: 0}}>While there are no direct competitors, some companies are developing similar technology used for other purposes.</p>
                                    <div className={"competitors-container"}>
                                        <Competitor
                                            src={Competitor1}
                                            alt={""}
                                            name={"Affectiva"}>
                                        </Competitor>
                                        <Competitor
                                            src={Competitor2}
                                            alt={""}
                                            name={"Empowered Brain"}>
                                        </Competitor>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>

                <WorkSection id={"user-research"} ref={userResearchRef} style={{scrollMarginTop: getScrollMarginTop(userResearchRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>User research</p>
                                        <h2 className={"h3"}>Pain points</h2>
                                        <Container>
                                            <Row >
                                                <Col xs={12} md={12} className={"col-md-left"}>
                                                    <div className={"pain-points-container"}>
                                                        <PainPoint
                                                            src={TargetAudiencePink}
                                                            alt={""}
                                                            quote1={"“"}
                                                            semibold={"People expect me to just 'get it'"}
                                                            quote2={" when they make a face or change their tone—but I don’t.”"}
                                                        ></PainPoint>
                                                        <PainPoint
                                                            src={TargetAudienceOrange}
                                                            alt={""}
                                                            quote1={"“I'm constantly second-guessing myself. Did I offend them?"}
                                                            semibold={" Did I miss something"}
                                                            quote2={"?”"}
                                                        ></PainPoint>
                                                        <PainPoint
                                                            src={TargetAudienceBlue}
                                                            alt={""}
                                                            quote1={"“Therapy helps, but in the moment,"}
                                                            semibold={" I feel alone and unsure of what to do"}
                                                            quote2={".”"}
                                                        ></PainPoint>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>Personas</h2>
                                        <div className={"personas-container"}>
                                            <Persona src={Persona1} alt={""} name={"Maya"} className={"interests aspirations frustrations behaviors"} demographics={persona1Demographics} interests={persona1Interests} aspirations={persona1Aspirations} frustrations={persona1Frustrations} behaviors={persona1Behaviors}>
                                            </Persona>
                                            <Persona src={Persona2} alt={""} name={"Chris"} className={"interests aspirations frustrations behaviors"} demographics={persona2Demographics} interests={persona2Interests} aspirations={persona2Aspirations} frustrations={persona2Frustrations} behaviors={persona2Behaviors}>
                                            </Persona>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id={"challenge"} className={"challenge dark-background"} ref={challengeRef} style={{scrollMarginTop: getScrollMarginTop(challengeRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12} lg={9}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Challenge</p>
                                        <h2 className={"h3"}>Problem statement</h2>
                                        <p className={"no-margin description"}>Users struggle to interpret emotional cues and manage sensory input in social environments, leading to discomfort and communication barriers.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id="analysis" className={"grey"} ref={analysisRef} style={{scrollMarginTop: getScrollMarginTop(analysisRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Analysis</p>
                                        <h2 className={"h3"}>User flows</h2>
                                        <h3 className={"h4"}>AR glasses</h3>

                                        <img src={UserJourneyARDesktop} alt={""} style={{borderRadius:0, maxWidth: 650, marginBottom: 48}} className={"d-none d-md-block"}></img>

                                        <img src={UserJourneyARMobile} alt={""} style={{borderRadius:0, marginTop: 12, marginBottom: 36, maxWidth: 460}} className={"d-md-none"}></img>

                                        <div className={"sr-only"}>
                                            <p>In the AR glasses user flow, users wear the device and can either begin an interaction or adjust the settings. If they choose to start an interaction, they receive cues from the device, respond to cues, and can check their progress in the mobile app after the interaction. If they adjust settings, they can adjust connections, modes, accessibility, display, audio, security/privacy, languages, or user settings. They also have the option to view tips and tutorials from the settings screen.</p>
                                        </div>

                                        <h3 className={"h4"}>Mobile app</h3>

                                        <img src={UserJourneyAppDesktop} alt={""} style={{borderRadius:0}} className={"d-none d-md-block"}></img>

                                        <img src={UserJourneyAppMobile} alt={""} style={{borderRadius:0, marginTop: 12}} className={"d-md-none"}></img>

                                        <div className={"sr-only"}>
                                            <p>In the mobile app user flow, users open the app and either login or sign up. Then, starting from the home screen, they can go to the activity, goals, favorites, or settings screens, or they can add an emotion. On the activity and goals screens, they can see information in a daily, weekly, and/or monthly view. In the favorites screen, they can view, add, or delete favorites. In the settings screen, they can adjust settings for the app or the AR device. If they choose to add an emotion, they can select an emotion and then answer the presented questions to refine their emotion. Then, they save the emotion.</p>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id={"iterations"} className={"design-iterations"} ref={iterationsRef} style={{scrollMarginTop: getScrollMarginTop(iterationsRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Design iterations</p>
                                        <h2 className={"h3"}>Sketches</h2>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                    <p>To help users address their challenges, we designed a pair of glasses that uses augmented reality to overlay a user interface on the user's vision. This interface provides visual cues about people's moods and other nonverbal communication.</p>
                                                    <p>The glasses also offer noise cancellation and verbal cues via bone-conducting speakers and physical buttons for navigating the interface.</p>
                                                    <p>In the accompanying mobile app, users can log emotions, set interaction goals, track their progress, save interactions with their "favorites," and adjust settings.</p>
                                                </Col>
                                            </Row>
                                        </Container>
                                        <h3 className={"h4"}>AR glasses</h3>
                                        <img src={GlassesSketches} alt={""} style={{borderRadius: 0, maxWidth: 600, marginBottom: 60}}></img>
                                        <img src={ARSketches} alt={""} style={{borderRadius: 0}}></img>
                                        <p className={"img-caption margin-bottom-16"}>Sketches of the AR glasses and their interface.</p>
                                        <h3 className={"h4"}>Mobile app</h3>
                                        <img src={AppSketches} alt={""} style={{borderRadius: 0}}></img>
                                        <p className={"img-caption"}>Sketches  of the home screen and the login, goals, activity, favorites, and settings user flows.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id={"final-design"} className={"final-design grey"} ref={finalDesignRef} style={{scrollMarginTop: getScrollMarginTop(finalDesignRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Final design</p>
                                        <h2 className={"h3"}>Final deliverables</h2>
                                        <h3 className={"h4"}>AR glasses</h3>
                                        <p><a href={"https://www.figma.com/proto/Sk3FpGU3K3MZ0SgKbHWJ9D/InSight-App?node-id=653-169&p=f&t=K22VdhaK4OVGGGmx-1&scaling=min-zoom&content-scaling=fixed&page-id=653%3A70&starting-point-node-id=653%3A169&show-proto-sidebar=1"} target={"_blank"} rel="noreferrer" style={{outlineOffset: 4, borderRadius: 2}}>View interactive AR glasses prototype<span style={{marginLeft: 4}}><FontAwesomeIcon icon={faExternalLink} style={{fontSize: 12}}/></span></a></p>
                                        <img src={FinalGlasses} alt={""}></img>
                                        <p className={"img-caption margin-bottom-16"}>Final design of the InSight AR Glasses user interface.</p>
                                        <h3 className={"h4"}>Mobile app</h3>
                                        <p><a href={"https://www.figma.com/proto/Sk3FpGU3K3MZ0SgKbHWJ9D/InSight-App?node-id=149-2376&p=f&t=wL23bfLIs5VjllpZ-1&scaling=min-zoom&content-scaling=fixed&page-id=149%3A818&starting-point-node-id=149%3A2376&show-proto-sidebar=1"} target={"_blank"} rel="noreferrer" style={{outlineOffset: 4, borderRadius: 2}}>View interactive app prototype<span style={{marginLeft: 4}}><FontAwesomeIcon icon={faExternalLink} style={{fontSize: 12}}/></span></a></p>
                                        <img src={FinalApp} alt={""}></img>
                                        <p className={"img-caption"}>Final design of the InSight mobile app.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h3 className={"h4 section-title"}>User testing insights</h3>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                    <p>Based on testing with 3 users from the target audience, our team would make the following changes to the product:</p>
                                                    <div className={"insights-container no-title"}>
                                                        <Insight
                                                            number={"01"}
                                                            title={"AR glasses and interface"}
                                                            description={UserTesting1}>
                                                        </Insight>
                                                        <Insight
                                                            number={"02"}
                                                            title={"Mobile app"}
                                                            description={UserTesting2}>
                                                        </Insight>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id={"reflections"} className={"reflections dark-background"} ref={reflectionsRef} style={{scrollMarginTop: getScrollMarginTop(reflectionsRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Reflections</p>
                                        <h2 className={"h3"}>What I learned</h2>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                    <p className="summary" style={{marginBottom: 16}}>This project was a learning experience for me, as I was forced to consider user needs for a non-standard device. While designing for AR glasses presents new challenges, I learned that the key UX principles still apply.</p>
                                                    <p className={"summary"}>I enjoyed collaborating with my team to research, design for, and test on neurodiverse users, and I gained insight on their unique needs that will help me in future projects.</p>
                                                    <div className={"insights-container"}>
                                                        <Insight
                                                            number={"01"}
                                                            title={"Subtlety is key"}
                                                            description={"When designing for assistive technology, it's important to avoid overwhelming users with too much information at once. The goal is to help them, not distract them!"}>
                                                        </Insight>
                                                        <Insight
                                                            number={"02"}
                                                            title={"One size doesn't fit all"}
                                                            description={"Neurodivergent users have highly varied needs, and allowing them the necessary customization options can make or break the user experience."}>
                                                        </Insight>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection className={"recommendations"} id="reflections">
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>Explore other projects</h2>
                                        <Container>
                                            <Row style={{rowGap: 24, justifyContent: "space-between"}}>
                                                <Col xs={12} sm={6} md={4} lg={3} className={"work-recommendation-container"}>
                                                    <WorkRecommendation
                                                        src={SouthwestThumbnail}
                                                        alt={"Three screens from the redesigned Southwest Airlines app"}
                                                        title={"Southwest Airlines"}
                                                        description={"App redesign (concept)"}
                                                        href={"/southwest-app-redesign"}>
                                                    </WorkRecommendation>
                                                </Col>
                                                <Col xs={12} sm={6} md={4} lg={3} className={"work-recommendation-container"}>
                                                    <WorkRecommendation
                                                        src={DignifiThumbnail}
                                                        alt={"Three screens from the Dignifi app"}
                                                        title={"Dignifi"}
                                                        description={"App design"}
                                                        href={"/dignifi-app-design"}>
                                                    </WorkRecommendation>
                                                </Col>
                                                <Col xs={12} sm={6} md={4} lg={3} className={"work-recommendation-container"}>
                                                    <WorkRecommendation
                                                        src={SmartHomeThumbnail}
                                                        alt={"Mobile and desktop views of the Renesas Smart Home infographic"}
                                                        title={"Renesas Smart Home"}
                                                        description={"Interactive infographic"}
                                                        href={"/smart-home-infographic"}>
                                                    </WorkRecommendation>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
            </div>
        </main>
    )
}

export default InSightAppDesign;